export default __webpack_public_path__ + "static/media/rick.62fb2be6.png";